import {ChangeDetectionStrategy, Component, Input} from '@angular/core';

@Component({
    selector: 'myabvv-loader',
    standalone: true,
    templateUrl: './loader.component.html',
    styleUrls: ['loader.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoaderComponent  {
  @Input() message: string;

  constructor() {
  }
}
